import React, { useState } from 'react';
import { 
    Box, Paper, Typography, TextField, Button, Stack, 
    Alert, IconButton, InputAdornment, Link as MuiLink 
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { authService } from '../api';

const SignUp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        role: 'CLIENT' // Rol por defecto para auto-registro
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await authService.register(formData);
            navigate('/login', { state: { message: t('signup_success') } });
        } catch (err) {
            const detail = err.response?.data;
            if (typeof detail === 'object') {
                // Extraer el primer mensaje de error disponible (email duplicado, etc)
                const firstError = Object.values(detail)[0];
                setError(Array.isArray(firstError) ? firstError[0] : firstError);
            } else {
                // Error de conexión o 500 del servidor
                setError("Error en el servidor al procesar el registro.");
            }
        }
    };

    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '80vh' 
        }}>
            <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 450, borderRadius: 4 }}>
                <Typography variant="h4" gutterBottom fontWeight="bold" align="center" color="primary">
                    TicSmart
                </Typography>
                <Typography variant="h6" gutterBottom align="center" sx={{ mb: 3 }}>
                    {t('signup_title')}
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                <form onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                        <Stack direction="row" spacing={2}>
                            <TextField
                                label={t('signup_first_name')}
                                name="first_name"
                                fullWidth
                                required
                                onChange={handleChange}
                            />
                            <TextField
                                label={t('signup_last_name')}
                                name="last_name"
                                fullWidth
                                required
                                onChange={handleChange}
                            />
                        </Stack>
                        <TextField
                            label={t('signup_email')}
                            name="email"
                            type="email"
                            fullWidth
                            required
                            onChange={handleChange}
                        />
                        <TextField
                            label={t('signup_password')}
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            fullWidth
                            required
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <Button type="submit" variant="contained" size="large" fullWidth sx={{ mt: 2, py: 1.5 }}>
                            {t('signup_button')}
                        </Button>
                        <Box sx={{ textAlign: 'center', mt: 2 }}>
                            <MuiLink component={Link} to="/login" variant="body2" underline="hover">
                                {t('signup_login_link')}
                            </MuiLink>
                        </Box>
                    </Stack>
                </form>
            </Paper>
        </Box>
    );
};

export default SignUp;